import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const InboundConsolidationDocumentKinds = ["manifest"] as const;
export type InboundConsolidationDocumentKind =
  (typeof InboundConsolidationDocumentKinds)[number];

export const InboundConsolidationDocumentFormats = ["csv", "pdf"] as const;
export type InboundConsolidationDocumentFormat =
  (typeof InboundConsolidationDocumentFormats)[number];

const inboundConsolidationDocumentSchema_ = z.object({
  kind: z.enum(InboundConsolidationDocumentKinds),
  formats: z.array(z.enum(InboundConsolidationDocumentFormats)),
});
export const inboundConsolidationDocumentSchema: z.ZodType<InboundConsolidationDocument> =
  inboundConsolidationDocumentSchema_;
export interface InboundConsolidationDocument extends z.infer<
  typeof inboundConsolidationDocumentSchema_
> {}

const consolidationInput = z.object({ consolidationId: z.string() });
const documentUrlOutput = z.object({ url: z.string() });

export const listInboundConsolidationDocuments = unaryRpc({
  name: "listInboundConsolidationDocuments" as const,
  input: consolidationInput,
  output: z.object({ documents: z.array(inboundConsolidationDocumentSchema) }),
});

export const getInboundConsolidationManifestCsv = unaryRpc({
  name: "getInboundConsolidationManifestCsv" as const,
  input: consolidationInput,
  output: documentUrlOutput,
});

export const getInboundConsolidationManifestPdf = unaryRpc({
  name: "getInboundConsolidationManifestPdf" as const,
  input: consolidationInput,
  output: documentUrlOutput,
});
